export default __webpack_public_path__ + "static/media/HI_1.9c51ebab.wav";